//Include Both Helper File with needed methods
import { postLogin, postResync, logout } from "../../../helpers/backend_helper";

import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
  shouldResync,
} from "./reducer";

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    let response;
    response = postLogin({
      username: user.username,
      password: user.password,
    });
    const data = await response;
    let loginResponse: any = JSON.stringify(data);
    loginResponse = JSON.parse(loginResponse);
    if (loginResponse) {
      switch (loginResponse.code) {
        case "000":
          dispatch(loginSuccess(loginResponse.data));
          history("/apps");
          break;

        case "002":
          dispatch(shouldResync(user));
          history("/resync");
          break;

        default:
          dispatch(apiError(loginResponse));
          break;
      }
    } else {
      dispatch(apiError(loginResponse));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resyncUser =
  (user: any, history: any) => async (dispatch: any) => {
    try {
      let response;
      response = postResync({
        username: user.username,
        password: user.password,
        password2: user.newpassword,
      });
      const data = await response;
      let resyncResponse: any = JSON.stringify(data);
      console.log({ data });
      resyncResponse = JSON.parse(resyncResponse);
      if (resyncResponse) {
        if (resyncResponse.code === "000") {
          history("/login");
        } else {
          dispatch(apiError(resyncResponse));
        }
      }
    } catch (error) {
      dispatch(apiError(error));
    }
  };
export const logoutUser = () => async (dispatch: any) => {
  try {
    let response;
    response = logout();
    const data = await response;
    if (data) {
      dispatch(logoutUserSuccess(true));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
